import Env from "../constant/env.json";

const showFile = (file_id) => {
  return `${Env.storage_url}${file_id}`;
};
export default showFile;
